import { ReactComponent as cancelOutline } from './icons/cancel_outline.svg';


const IconSource = {
  cancel_outline: cancelOutline
};

export default IconSource;
